<template>
  <div>
    <template v-if="buyer">
      <b-row>
        <b-col :lg="12">
          <ol class="breadcrumb arr-right mb-0 mb-md-3">
            <li class="breadcrumb-item headings">
              {{ $t('buyers.index.title') }}
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'buyers' }" class="headings">{{
                $t('buyers.index.limits')
              }}</router-link>
            </li>
            <li class="breadcrumb-item reference-heading">
              {{ buyer.importer }}
              <span class="stage-heading">{{
                $t(`buyers.index.status['${buyer.new_portal_status}']`)
              }}</span>
            </li>
          </ol>
        </b-col>
        <b-col :lg="9" :order="2" :order-md="1" class="pb-4">
          <div class="drip-card">
            <buyer-summary :buyer="buyer"></buyer-summary>
          </div>
        </b-col>
        <b-col :lg="3" :order="0" :order-md="2" :cols="12">
          <buyer-list-alerts
            class="mb-3"
            @filter-invoices="setFiltersandRedirect"
            :customer-pending-tasks="pendingTasks"
          />
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import BuyerSummary from '@/components/buyer/Summary'
import BuyerListAlerts from '../../components/invoices/list/Alerts'
import { freshdeskMixin } from '@/mixins/Freshdesk'
import exportersService from '@/services/exporters'
import buyersService from '@/services/buyers'

export default {
  data() {
    return {
      test: 'test',
      buyer: null,
      pendingTasks: []
    }
  },
  mounted() {
    this.assignPageTitle()
    this.loadBuyer()
    if (this.$store.state.account.accountId) {
      this.loadPendingTasks()
    }
  },
  methods: {
    assignPageTitle() {
      if (this.buyer) {
        document.title = `${this.buyer?.importer} | Buyers | Drip Portal`
      } else {
        document.title = `Buyers | Drip Portal`
      }
    },
    loadBuyer() {
      buyersService
        .fetchBuyersDetails(this.$route.params.id, {
          include: ['plan']
        })
        .then((res) => {
          this.buyer = res.data
          if (this.$store.state.account.country === 'India') {
            this.showAndPrefillFreshdesk(
              {
                cf_category_i: 'Buyer related',
                cf_importer_id: this.buyer.importer_user_id,
                cf_importer_name: this.buyer.importer,
                cf_client_id: this.$route.params.id,
                cf_link_to_dashboard: `${process.env.VUE_APP_DRIP_ADMIN_HOST}/admin/importers/${this.buyer.importer_user_id}/clients/${this.$route.params.id}`
              },
              `Support Ticket | ${this.buyer.importer} | Drip Capital`
            )
          }
        })
    },
    setFiltersandRedirect(newFilters) {
      this.$router.push({
        name: 'invoices',
        params: { alertFilters: newFilters }
      })
    },
    loadPendingTasks() {
      return exportersService
        .fetchExporterMetaData(this.$store.state.account.accountId, {
          include: ['customer_pending_task_flows']
        })
        .then((res) => {
          this.pendingTasks = res.data.customer_pending_task_flows
        })
        .catch(console.error)
    }
  },
  components: {
    BuyerSummary,
    BuyerListAlerts
  },
  mixins: [freshdeskMixin]
}
</script>
